import { render } from "./HomePage.vue?vue&type=template&id=48ecdfb3&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=48ecdfb3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\z4613\\Downloads\\461374167.github.io-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ecdfb3"]])

export default __exports__